var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
// Should be safe, meant to be injected
// TODO: Should we setup a different API key for staging?
var PENDO_API_KEY = 'e93cbd2e-68ee-4075-7484-9191056e7226';
export var usePendo = function (_a) {
    var visitor = _a.visitor, account = _a.account, isLoading = _a.isLoading, error = _a.error;
    var PENDO_SCRIPT_ID = 'pendo';
    useEffect(function () {
        // Only initialize if we have the required data
        if (isLoading || error || !visitor || !account) {
            return;
        }
        // Prevent multiple script injections
        if (document.querySelector("#".concat(PENDO_SCRIPT_ID)) !== null) {
            return;
        }
        // Set up Pendo API methods and queue (per Pendo's default script)
        window.pendo = window.pendo || {};
        var pendo = window.pendo;
        pendo._q = pendo._q || [];
        var methods = [
            'initialize',
            'identify',
            'updateOptions',
            'pageLoad',
            'track',
        ];
        methods.forEach(function (method) {
            pendo[method] =
                pendo[method] ||
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        pendo._q[method === 'initialize' ? 'unshift' : 'push'](__spreadArray([
                            method
                        ], __read(args), false));
                    };
        });
        // Inject the Pendo script at the end of body
        var script = document.createElement('script');
        script.async = true;
        script.src = "https://cdn.pendo.io/agent/static/".concat(PENDO_API_KEY, "/pendo.js");
        script.id = PENDO_SCRIPT_ID;
        document.body.appendChild(script);
        // Call initialize after script insertion - it will be queued and executed when script loads
        pendo.initialize({
            visitor: {
                id: visitor.id,
                email: visitor.email,
                firstName: visitor.firstName,
                lastName: visitor.lastName,
                roles: visitor.roles,
            },
            account: {
                id: account.id,
                name: account.name,
            },
        });
    }, [isLoading, error, visitor, account]);
};
